/**
 * User: herbert
 */

import React from 'react';
import Reflux from 'reflux';
import velocity from 'velocity-animate';
import 'velocity-ui-pack';
import userStore from '../stores/user-store.js';
import userActions from '../actions/user-actions.js';
import storageActions from '../actions/storage-actions.js';

import T from '../../../nls/translate.js';



export default React.createClass({
	mixins: [
		Reflux.connect(userStore, 'data') // this.state.data entspricht parameter von trigger() bei output: des stores, hier: ein Array mit StepPart-Elementen
	],
	handleLogin: function() {
		userActions.login(this.refs.loginuser.value, this.refs.loginpass.value, this.errorCallback);
		// nach erfolgreichem Login und wenn this.refs.prices existiert, dieses setzen
	},
	handleLoginKey: function(e) {
		if(e.keyCode === 13)
			this.handleLogin();
	},
	handleLogoutKey: function(e) {
		if(e.keyCode === 13)
			userActions.logout();
	},
	handlePricesClick: function() {
		userActions.showPrices(!this.state.data.pricesRequested, this.errorCallback); // use errorCallback as passwordFailCallback
	},
	handlePricesKey: function(e) {
		if(e.keyCode === 32) // Leerzeichen, Return passiert automatisch, da <button>
			this.handlePricesClick();
	},
	handleLoad: function() {
		if(this.refs.confid && this.refs.confid.value && this.refs.confid.value !== '')
			storageActions.fetch(this.refs.confid.value, this.errorCallback);
	},
	handleLoadKey: function(e) {
		if(e.keyCode === 13)
			this.handleLoad();
	},
	handleLoadButtonKey: function(e) {
		if(e.keyCode === 13)
			this.handleLoad();
	},
	errorCallback: function(error, /**http.IncomingMessage*/ response, /**JSON*/ body) {
		console.log('error', error, /**http.IncomingMessage*/ response, /**JSON*/ body);
		// do some SFX to show error
		velocity(this.refs.loginshaker, 'callout.shake');
	},
	renderLogin: function() {
		return (
			<div className="slx-user-login">
				<label htmlFor="username">{T.current.USER.USERNAME}</label><br />
				<input id="username" ref="loginuser" type="text" onKeyUp={this.handleLoginKey} autoFocus={true} /><br />
				<label htmlFor="passwor">{T.current.USER.PASSWORD}</label><br />
				<input id="password" type="password" ref="loginpass" onKeyUp={this.handleLoginKey} /><br />
				<button onClick={this.handleLogin}>{T.current.USER.LOGIN_BUTTON}</button><br />
			</div>
		);
	},
	renderSettings: function() {
		//console.log(this.state.data, (this.state.data.pricesRequested?' slx-user-box--checkbox__checked':''), this.state.data.pricesRequested);
		const elems = [
			<div key="ls" className="slx-user-loadstele">
				<label htmlFor="confid">{T.current.USER.LOAD_TEXT}</label><br />
				<input id="confid" ref="confid" type="text" onKeyUp={this.handleLoadKey} autoFocus={!this.state.data.pricesAllowed} /><br />
				<button onClick={this.handleLoad} onKeyUp={this.handleLoadButtonKey} >{T.current.USER.LOAD_BUTTON}</button><br />
			</div>
		];
		if(this.state.data.pricesAllowed) {
			elems.unshift(
				<div key="s" className="slx-user-settings">
					<button id="prices" ref="prices" className={'slx-user-box--checkbox' + (this.state.data.pricesRequested?' slx-user-box--checkbox__checked':'')} onKeyUp={this.handlePricesKey} onClick={this.handlePricesClick} autoFocus={true} >
						{T.current.USER.PRICES_TEXT}
					</button>
					<br />
				</div>
			);
		}
		return elems;
	},
	renderTitle: function() {
		if(this.state.data.user)  {
			return (
				<div className="slx-user-box__title">
					<div className="slx-user-box__close" onClick={userActions.close} role="button" />
					<span>{this.state.data.user}</span>
					<button onClick={userActions.logout} onKeyUp={this.handleLogoutKey} >{T.current.USER.LOGOUT_BUTTON}</button><br />
				</div>
			);
		} else {
			return (
				<div className="slx-user-box__title">
					<div className="slx-user-box__close" onClick={userActions.close} role="button" />
					<span>{T.current.USER.LOGIN_TEXT}</span>
				</div>
			);
		}
	},
	render: function() {
		const content = this.state.data.user ? this.renderSettings() : this.renderLogin();
		const title = this.renderTitle();
		return (!this.state.data.visible ? <div /> : (
				<div id="loginshaketarget" ref="loginshaker" className="slx-user-box">
					{title}
					{content}
				</div>)
		);
	},
});
